module.exports = __webpack_public_path__ + "static/img/5.0af2414.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/5.png
// module id = 5Y8N
// module chunks = 0